<script setup lang="ts">
import Error from '@/components/Error.vue';
</script>

<template>
  <error
    :icon="'mdi-alert-circle'"
    :title="'Missing warehouse'"
    :message="'The link is invalid, it must contain the warehouse id'" />
</template>
